import React from 'react';

/**
 * Fallback used when a LaunchDarkly provider fails to initialize: renders
 * children without a provider so flag reads fall back to their defaults (the
 * legacy flow) instead of leaving the subtree stuck on a loading spinner.
 */
export function PassThroughProvider({
  children,
}: React.PropsWithChildren): React.ReactNode {
  return children;
}
